/* Carrousel de vidéos (sections/video-carousel.liquid) :
   - le clic sur l'affiche remplace la façade par l'iframe (lecture automatique) ;
   - un iframe capte les gestes du doigt (avance rapide…) : on ne peut plus glisser dessus. La
     rangée « flèche · points · flèche » sous le carrousel (hors de l'iframe) change de vidéo, et
     quand le carrousel change de diapositive la vidéo en cours est arrêtée (l'affiche revient).
   Délégation sur le document : fonctionne aussi pour les sections rechargées dans l'éditeur. */
(function () {
    if (window.__videoCarousel) return;
    window.__videoCarousel = true;

    function push(obj) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(obj);
    }

    // Remet l'affiche à la place de l'iframe (arrête la lecture)
    function stop(slide) {
        var iframe = slide.querySelector('iframe');
        if (iframe && slide.__poster) slide.replaceChild(slide.__poster, iframe);
    }

    function stopAll(carousel) {
        carousel.querySelectorAll('[data-video-slide]').forEach(stop);
    }

    // Le carrousel (slideshow-inline) précède la rangée de commandes dans le même bloc
    function controlsOf(carousel) {
        var block = carousel.closest('.video-carousel-block');
        return block ? block.querySelector('.video-carousel-controls') : null;
    }

    function carouselOf(control) {
        var block = control.closest('.video-carousel-block');
        return block ? block.querySelector('slideshow-inline') : null;
    }

    // Même retrait gauche/droite que le carrousel (marge de page posée en JS par slideshow-inline)
    function alignControls(carousel) {
        var controls = controlsOf(carousel);
        var el = carousel.querySelector('.swiper');
        if (!controls || !el) return;
        var cs = window.getComputedStyle(el);
        controls.style.paddingLeft = cs.paddingLeft;
        controls.style.paddingRight = cs.paddingRight;
    }

    // Points + état des flèches d'après la position du Swiper
    function sync(carousel) {
        var controls = controlsOf(carousel);
        var swiper = carousel.swiper;
        if (!controls || !swiper) return;
        var index = swiper.snapIndex != null ? swiper.snapIndex : swiper.activeIndex;
        controls.querySelectorAll('.video-carousel-dot').forEach(function (dot, i) {
            var on = i === index;
            dot.classList.toggle('@active', on);
            if (on) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
        });
        var prev = controls.querySelector('[data-video-prev]');
        var next = controls.querySelector('[data-video-next]');
        if (prev) prev.disabled = !!swiper.isBeginning && !swiper.params.loop;
        if (next) next.disabled = !!swiper.isEnd && !swiper.params.loop;
    }

    function buildDots(carousel) {
        var controls = controlsOf(carousel);
        var holder = controls && controls.querySelector('[data-video-dots]');
        var swiper = carousel.swiper;
        if (!holder || !swiper || holder.childNodes.length) return;
        var count = swiper.snapGrid ? swiper.snapGrid.length : swiper.slides.length;
        for (var i = 0; i < count; i++) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'video-carousel-dot';
            dot.setAttribute('data-video-dot', i);
            dot.setAttribute('aria-label', (i + 1) + ' / ' + count);
            holder.appendChild(dot);
        }
    }

    // L'instance Swiper est créée par slideshow-inline.js après le chargement : on l'attend.
    function watch(carousel) {
        if (carousel.__videoWatch) return;
        carousel.__videoWatch = true;
        var tries = 0;
        var timer = window.setInterval(function () {
            tries++;
            if (carousel.swiper && carousel.swiper.on) {
                window.clearInterval(timer);
                buildDots(carousel);
                alignControls(carousel);
                sync(carousel);
                carousel.swiper.on('slideChange', function () {
                    stopAll(carousel);
                    sync(carousel);
                });
                carousel.swiper.on('resize', function () { alignControls(carousel); sync(carousel); });
            } else if (tries > 50) {
                window.clearInterval(timer);
            }
        }, 200);
    }

    function init() {
        document.querySelectorAll('slideshow-inline').forEach(function (c) {
            if (c.querySelector('[data-video-slide]')) watch(c);
        });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    document.addEventListener('click', function (e) {
        if (!e.target.closest) return;

        // Flèches et points de la rangée sous le carrousel
        var ctrl = e.target.closest('[data-video-prev], [data-video-next], [data-video-dot]');
        if (ctrl) {
            var car = carouselOf(ctrl);
            if (!car || !car.swiper) return;
            if (ctrl.hasAttribute('data-video-dot')) {
                car.swiper.slideTo(parseInt(ctrl.getAttribute('data-video-dot'), 10));
                push({ event: 'product_video_nav', direction: 'dot' });
            } else if (ctrl.hasAttribute('data-video-next')) {
                car.swiper.slideNext();
                push({ event: 'product_video_nav', direction: 'next' });
            } else {
                car.swiper.slidePrev();
                push({ event: 'product_video_nav', direction: 'prev' });
            }
            return;
        }

        var carousel = e.target.closest('slideshow-inline');
        var btn = e.target.closest('[data-video-play]');
        if (!btn) return;
        var slide = btn.closest('[data-video-slide]');
        if (!slide) return;
        var src = slide.getAttribute('data-embed');
        if (!src) return;
        if (carousel) { watch(carousel); stopAll(carousel); }
        var iframe = document.createElement('iframe');
        iframe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.setAttribute('title', btn.getAttribute('aria-label') || 'Video');
        slide.__poster = btn;
        slide.replaceChild(iframe, btn);
        push({ event: 'product_video_play', video_url: src });
    });
})();
